import React from "react";

import { useState, useEffect } from "react";
import "./Edit_shipping_address.css";
import { useNavigate } from "react-router-dom";

const shippingFields = [
  {
    label: "First name *",
    name: "first_name",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  },
  {
    label: "Last name *",
    name: "last_name",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  },
  {
    label: "Company name (optional)",
    name: "company_name",
    type: "text",
    placeholder: "",
    disable: false,
    required: false,
  },
  {
    label: "Country / Region *",
    name: "country_region",
    type: "text",
    placeholder: "",
    disable: true,
    required: true,
    value: "India",
  },
  {
    label: "Street address *",
    name: "street_address",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  },
  {
    label: "Apartment, suite, etc. (optional)",
    name: "apartment",
    type: "text",
    placeholder: "",
    disable: false,
    required: false,
  },
  {
    label: "Town / City *",
    name: "city",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  },
  {
    label: "State *",
    name: "state",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  },
  {
    label: "Pincode *",
    name: "pincode",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  }
];
const billingFields = [
  {
    label: "First name *",
    name: "first_name",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  },
  {
    label: "Last name *",
    name: "last_name",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  },
  {
    label: "Company name (optional)",
    name: "company_name",
    type: "text",
    placeholder: "",
    disable: false,
    required: false,
  },
  {
    label: "GSTIN (optional)",
    name: "gstin",
    type: "text",
    placeholder: "",
    disable: false,
    required: false,
  },
  {
    label: "Salesman's name (optional)",
    name: "salesman_name",
    type: "text",
    placeholder: "",
    disable: false,
    required: false,
  },
  {
    label: "Store name (optional)",
    name: "store_name",
    type: "text",
    placeholder: "",
    disable: false,
    required: false,
  },
  {
    label: "Country / Region *",
    name: "country_region",
    type: "text",
    placeholder: "",
    disable: true,
    required: true,
    value: "India",
  },
  {
    label: "Landmark *",
    name: "landmark",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  },
  {
    label: "Street address *",
    name: "street_address",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  },
  {
    label: "Apartment, suite, etc. (optional)",
    name: "apartment",
    type: "text",
    placeholder: "",
    disable: false,
    required: false,
  },
  {
    label: "Town / City *",
    name: "city",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  },
  {
    label: "State *",
    name: "state",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  },
  {
    label: "Pincode *",
    name: "pincode",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  },
  {
    label: "Phone *",
    name: "phone",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  },
  {
    label: "Email *",
    name: "email",
    type: "email",
    placeholder: "",
    disable: false,
    required: true,
  },
];
const EditShippingAddressForm = () => {

  const commonFields = billingFields
    .filter((billingField) =>
      shippingFields.some(
        (shippingField) => shippingField.name === billingField.name
      )
    )
    .map((field) => field.name);

  const uncommonFields = billingFields
    .filter((billingField) => !shippingFields.some((shippingField) => shippingField.name === billingField.name))
    .map((field) => field.name);

  const [formValues, setFormValues] = useState(
    shippingFields.reduce((acc, field) => {
      acc[field.name] = field.value || "";
      return acc;
    }, {})
  );
  const [token, setToken] = useState('');
  const [billingAddress, setBillingAddress] = useState('');
  const navigate = useNavigate();

  const inCaseAbsent = [...commonFields, ...uncommonFields].reduce((acc, field) => {
    acc[field] = commonFields.includes(field) ? formValues[field] : "";
    return acc;
  }, {});

  // Populate form with existing data from localStorage if available
  useEffect(() => {
    const savedShippingAddress = localStorage.getItem("shipping_address");
    if (savedShippingAddress) {
      setFormValues(JSON.parse(savedShippingAddress));
    }
    const token = localStorage.getItem("token");
    if (token) {
      setToken(JSON.parse(token));
    } else {
      navigate("/register-login");
    }

    const billingAddress = localStorage.getItem("billing_address");
    if (billingAddress) {
      setBillingAddress(JSON.parse(billingAddress));
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    //console.log(formValues);
    //console.log(token);
    // console.log({
    //   "token": token,
    //   "shipping_address": formValues,
    //   "billing_address": billingAddress || inCaseAbsent,
    // });
    localStorage.setItem("shipping_address", JSON.stringify(formValues));
    try {
      const response = await fetch("https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/address-registration", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          "token": token,
          "shipping_address": formValues,
          "billing_address": billingAddress || inCaseAbsent,
        }),
      })
      const data = await response.json();
      //console.log(data);
    } catch (error) {
      console.error("Error updating billing address:", error);
    }
  };

  return (
    <div className="edit-shipping-address-container">
      <h2>Shipping Address</h2>
      <div className="edit-shipping-address-billing-form">
        <form onSubmit={handleSubmit}>
          {shippingFields.map((field, index) => (
            <div className="edit-shipping-address-form-group" key={index}>
              <label htmlFor={field.name}>{field.label}</label>
              <input
                id={field.name}
                name={field.name}
                type={field.type}
                placeholder={field.placeholder}
                disabled={field.disable}
                required={field.required}
                value={formValues[field.name]}
                onChange={handleChange}
              />
            </div>
          ))}
          <button className="edit-shipping-address-submit-btn" type="submit">
            Save Address
          </button>
        </form>
      </div>

    </div>

  );
};

export default EditShippingAddressForm;
